export function formatCpf(value, formatted = true) {
  return formatted
    ? value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    : value.replace(/(\.|-)/g, '');
}
